"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("rebass/styled-components");

var _styledComponents2 = require("@rebass/forms/styled-components");

var _md = require("react-icons/md");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children;
  return _react.default.createElement(_styledComponents.Flex, {
    flexWrap: "wrap",
    mt: 3
  }, _react.default.createElement(_styledComponents.Box, null, _react.default.createElement(_styledComponents.Text, {
    variant: "error"
  }, children)), _react.default.createElement(_styledComponents.Box, {
    ml: "auto",
    width: 16,
    flex: "none"
  }, _react.default.createElement(_styledComponents.Text, {
    variant: "error"
  }, _react.default.createElement(_md.MdWarning, null))));
};

ErrorMessage.propTypes = {
  children: _propTypes.default.any
};

var Input = function Input(props) {
  var StyledElement = _styledComponents2.Input;

  if (props.type === 'textarea') {
    StyledElement = _styledComponents2.Textarea;
  }

  return _react.default.createElement("div", null, _react.default.createElement(StyledElement, _extends({}, props, {
    variant: props.error ? 'error' : 'forms.input'
  })), props.error && _react.default.createElement(ErrorMessage, null, props.error));
};

Input.propTypes = {
  type: _propTypes.default.string,
  error: _propTypes.default.node,
  fontSize: _propTypes.default.number,
  rows: _propTypes.default.number
};
Input.defaultProps = {
  type: 'text',
  error: null,
  fontSize: 1,
  rows: 3,
  onChange: function onChange() {}
};
var _default = Input;
exports.default = _default;